import axios from 'axios';
import { baseURL } from '../constants/index';

var token = '';

// Update token Axios
export function updateJWToken(tokenParam) {
  token = tokenParam
  _axios.defaults.headers.Authorization = `JWT ${token}`
}

const _axios = axios.create({
  baseURL: baseURL,
  headers: {
    Authorization: `JWT ${token}`,
  }
})
export default _axios



// WEBPACK FOOTER //
// ./src/requesters/axios.js